import React from 'react';
import StudioTopBar from './components/StudioTopBar';
import StudioLeftSidebar from './components/StudioLeftSidebar';
import StudioCanvasArea from './components/StudioCanvasArea';
import StudioRightProperties from './components/StudioRightProperties';
import './styles/StudioPage.css';

const StudioPage = ({
  topContent,
  leftContent,
  rightContent,
  children,
  className = '',
  showTopBarTitle = true,
  topBarTitle = 'Studio',
  hideLeftSidebar = false,
}) => (
  <div className={`studio-page ${className}`.trim()}>
    <StudioTopBar title={topBarTitle} showTitle={showTopBarTitle}>
      {topContent}
    </StudioTopBar>
    <div className={`studio-body ${hideLeftSidebar ? 'studio-body-no-left' : ''}`.trim()}>
      {!hideLeftSidebar && (
        <StudioLeftSidebar>{leftContent}</StudioLeftSidebar>
      )}
      <StudioCanvasArea>{children}</StudioCanvasArea>
      <StudioRightProperties>{rightContent}</StudioRightProperties>
    </div>
  </div>
);

export default StudioPage;
